module.exports = __webpack_public_path__ + "img/boss_rev_ad.d901256c.gif";